"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignTypeTargeting = void 0;
class CampaignTypeTargeting {
    constructor(type, targetingLocations) {
        this.type = type;
        this.targetingLocations = targetingLocations;
    }
    type;
    targetingLocations;
}
exports.CampaignTypeTargeting = CampaignTypeTargeting;
//# sourceMappingURL=CampaignTypeTargeting.js.map